import { connect } from 'react-redux';
import { actions as userActions } from '../../redux/users';
import { blockChatParticipant } from '../../Chat/redux/actions';
const mapDispatchToProps = (dispatch, { chatroomId })=>({
        blockUser: (user)=>chatroomId ? dispatch(blockChatParticipant(user, chatroomId)) : dispatch(userActions.blockUser(user)),
        blockUserAndRedirect: (user, redirectLocation)=>dispatch(userActions.blockUserAndRedirect(user, redirectLocation))
    });
export default connect(null, mapDispatchToProps);

//# sourceMappingURL=UserBlockPopup.container.js.map